import CRUD from './genericCRUD'

const route = 'nurseries'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function nurseries(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		update: (body, config = {}) => {
			return instance.patch(`${route}`, body, config)
		},

		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {string} name
		 * @param {number} countryId
		 * @param {string} location
		 * @param {string} puc
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (
			pageNumber,
			pageSize,
			name,
			countryId,
			puc,
			location,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''
			const countryParam = countryId ? `countryId=${countryId}&` : ''
			const locationParam = location ? `location=${location}&` : ''
			const pucParam = puc ? `puc=${puc}&` : ''

			return instance.get(
				`${route}?${params}${nameParam}${locationParam}${countryParam}${pucParam}`,
				config
			)
		}
	}
}
